export const version = "providers/5.7.1";
//# sourceMappingURL=_version.js.map